import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { notificationTokenAtom } from "@Recoil/Atom/notificationTokenAtom"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { NotificationService } from "@Services/Notifications.Service"
import { SurveyService } from "@Services/Survey.Service"
import { UserService } from "@Services/User.service"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useContext, useState } from "react"
import { useRecoilState } from "recoil"

export const useNotifications = () => {
    const [fetchingPushNotificationToken, setFetchingPushNotificationToken] = useState(true)
    const [pushNotificationTokens, setPushNotificationTokens] = useState([])
    const [pushToken, setPushToken] = useRecoilState(notificationTokenAtom)
    const [notificationStatus, setNotificationStatus] = useRecoilState(notificationTokenAtom)
    const [registring, setRegistring] = useState(false)

    LocalStorage.getNotificationStatus().then((notificationStatus) => {
        setNotificationStatus(notificationStatus)
    })

    function registerNotificationForNewDevice() {
        setRegistring(true)
        NotificationService.registerForPushNotificationsAsync()
            .then((token) => {
                UserService.subscribeNotification(token)
                    .then((response) => {
                        console.log({ tokenVao: token })
                        setPushToken(token)
                        LocalStorage.saveNotificationStatus(true)
                    })
                    .catch((e) => {
                        setRegistring(false)
                    })
                setPushToken(token)
                setRegistring(false)
            })
            .catch((e) => {
                setRegistring(false)
            })
    }

    const fetchPushNotificationToken = async () => {
        setFetchingPushNotificationToken(true)
        UserService.getNotificationToken()
            .then((response) => {
                const data = response.data?.data
                const filtered = data?.filter((item) => item !== null)

                if (filtered?.length > 0) {
                    setPushNotificationTokens(filtered)
                    if (filtered?.includes(pushToken)) {
                        setPushToken(pushToken)
                    } else {
                        setPushToken(null)
                    }
                } else {
                    registerNotificationForNewDevice()
                }
                setFetchingPushNotificationToken(false)
            })
            .catch((e) => {
                setFetchingPushNotificationToken(false)
            })
    }

    return {
        fetchPushNotificationToken,
        fetchingPushNotificationToken,

        registerNotificationForNewDevice,
        pushNotificationTokens,

        notificationStatus
    }
}
